module.exports = [
    {name: 'materials.concrete', absorptionCoefficient: 0.03, absorptionClass: null, shapeIndicator: null},
    {name: 'materials.plasterTiles', absorptionCoefficient: 0.05, absorptionClass: null, shapeIndicator: null},
]

